import { ViewModel,View } from "binder"
import { FormBuilderComponent } from "src/formBuilder/structure/components";
import { FormBuilderElement, IFormBuilderElementVisitor } from "src/formBuilder/structure/element";
import { BooleanPropertyType, IntegerPropertyType, StringPropertyType } from "src/formBuilder/structure/propertyTypes/propetyTypes";
import  { MultiLineInputView } from "./multiLineInput-view"


export class MultiLineInputComponent extends FormBuilderComponent{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.name = 'MultiLineInput';
        this.addProperty("Text","data-b-comp-text",new StringPropertyType(this),"",false);
        this.addProperty("ReadOnly","data-b-comp-isreadonly",new BooleanPropertyType(this),false,false);
        this.addProperty("IsNumeric","data-b-comp-isnumeric",new BooleanPropertyType(this),false,false);
        this.addProperty("MaxLength","data-b-comp-maxlength",new IntegerPropertyType(this),null,false);
        this.addProperty("RowsHeight","data-b-comp-rowsheight",new IntegerPropertyType(this),null,false);
    }
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    CreateInternal(parent:ViewModel):FormBuilderElement{
        let result = new MultiLineInputViewModel(parent);
        return result;
    }
        
    protected getClassDefaultValue(){
        return "input";
    }
}

export class MultiLineInputViewModel extends FormBuilderElement{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new MultiLineInputView();
    }
    public getTypeId(): string {
        return "VM-26CA57CE-F1B1-46F3-A4E4-59C7C24FAD86"
    }
    public set Text(v: string) { this._Text = v; } public get Text(): string { return this._Text;} private _Text: string;
    public set ReadOnly(v: boolean) { this._ReadOnly = v; } public get ReadOnly(): boolean { return this._ReadOnly;} private _ReadOnly: boolean;
    public set IsNumeric(v: boolean) { this._IsNumeric = v; } public get IsNumeric(): boolean { return this._IsNumeric;} private _IsNumeric: boolean;
    public set MaxLength(v: number) { this._MaxLength = v; } public get MaxLength(): number { return this._MaxLength;} private _MaxLength: number;
    public set RowsHeight(v: number) { this._RowsHeight = v; } public get RowsHeight(): number { return this._RowsHeight;} private _RowsHeight: number;
    
    Accept(visitor: IFormBuilderElementVisitor, parameter: object): object {
        return visitor.VisitMultiLineInput(this,parameter);
    }
    
}
